import React, { FC, useContext, useState } from "react";

import { SocketContext, UserContext, TeamContext, CardContext, TableContext, BoardContext } from "../../../../../context";
import { InfoButton, SwapButton } from "../../../../atoms";
import { ICard } from "../../../../../interfaces";
import { CardType, Phase } from "../../../../../util/enums";
import { useSound } from "../../../../../hooks";

import PinkNotification from "../../../Notification/PinkNotification";
import { useTranslation } from "react-i18next";

interface SolutionCardProps {
    cardData: ICard;
    onCardClick?(type: CardType): void;
    choseSolution?(cardId: any): void;
    displayExchangeButton?: boolean;
    isForceHoverOn?: boolean;
    displayInfoOnTheProposedCard?: boolean;
    isThisCardSelectedByDilemmaOwner?: boolean;
    solutionCardsInHands?: boolean;
    cardIndex?: number;
    fullScreenIsOn?: boolean;
}

const SolutionCard: FC<SolutionCardProps> = (props) => {
    const { cardData, displayExchangeButton, onCardClick, choseSolution, displayInfoOnTheProposedCard, isForceHoverOn, solutionCardsInHands, cardIndex, fullScreenIsOn } = props

    const { t } = useTranslation();
    const { proposeSolutionCardSocketEvent, openNewSolutionCardSocketEvent, changeSoultionCardSocketEvent, withdrawCardSocketEvent } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const { userData, emailOfSelectedPlayerBoard, setNotificationAlert, setActivateAlert } = useContext(UserContext);
    const { flipSolutionCardBySelectedType } = useContext(CardContext);
    const { setAreAnimatedHandsShown, setToggleMySolutionFullScreen, isDilemmaChosen, didTheCurrentUserProposedSolution, solutionCardExchanged, setSolutionCardExchanged } = useContext(TableContext);
    const { instructionTutorial } = useContext(BoardContext);
    const isTheUserDilemaOwner = userData?.email === game?.gameInfo.currentPlayerEmail;
    const isFullScreenOnDuringPhase5 = game?.phase === Phase.QUESTION_CARD && isDilemmaChosen && !isTheUserDilemaOwner;
    const isFullScreenOnDuringPhase7 = game?.phase === Phase.CHOOSE_SOLUTION;

    const {playSound} = useSound();

    const [displayInfo, setDisplayInfo] = useState<boolean>(false);
    const [isExchangeButtonHovered, setIsExchangeButtonHovered] = useState<boolean>(false);
    const [isInfoButtonHovered, setIsInfoButtonHovered] = useState<boolean>(false);
    const [isCardHovered, setIsCardHovered] = useState<boolean>(false);

    const tokens = game?.gameInfo.players[emailOfSelectedPlayerBoard || ""]?.upperTokens || 0;

    const cardClickHandler = (type: CardType) => {
        if (onCardClick)
            onCardClick(type);
    }

    const doubleClickHandler = () => {
        setToggleMySolutionFullScreen(false);
        setSolutionCardExchanged(0)

        if (game?.phase === Phase.QUESTION_CARD) {
            if (didTheCurrentUserProposedSolution) withdrawCardSocketEvent();
            setAreAnimatedHandsShown(false);
            proposeSolutionCardSocketEvent(cardData.id, cardData.type);
            playSound("/sounds/LightClick.mp3");
        }

        
        if (isTheUserDilemaOwner && game?.phase !== Phase.CHOOSE_SOLUTION) {
            setNotificationAlert({message: t("youAreTheDilemmaOwnerYourTaskIsToChooseOneProposedCardText"), type:"regular"});
            setActivateAlert(true);
            return;
        }

        // proposeSolutionCardSocketEvent(cardData.id, cardData.type);
        // playSound("/sounds/LightClick.mp3");
        if (choseSolution && cardData.id)
            choseSolution(cardData.id);
    }

    const solutionCardsStyle = () => {
        switch (cardData.type) {
            case (CardType.JOKER_SOLUTION):
                return "front_side-emotional";
            case (CardType.EMOTIONAL_SOLUTION):
                    return "front_side-emotional";
            case (CardType.SOCIAL_SOLUTION):
                return "front_side-social";
            case (CardType.MENTAL_SOLUTION):
                    return "front_side-mental";
            case (CardType.PHYSICAL_SOLUTION):
                return "front_side-physical";
        };
    }

    const solutionSVGCards = () => {
        switch (cardData.type) {
            case (CardType.JOKER_SOLUTION):
                return "joker_card_front_side"
            case (CardType.EMOTIONAL_SOLUTION):
                return "emotional_card_front_side"
            case (CardType.SOCIAL_SOLUTION):
                return "social_card_front_side"
            case (CardType.MENTAL_SOLUTION):
                    return "mental_card_front_side"
            case (CardType.PHYSICAL_SOLUTION):
                return "physical_card_front_side"
        };
    }

    const solutionCardsTextIcon = () => {
        if (fullScreenIsOn) return "";
        
        switch (cardData.type) {
            case (CardType.JOKER_SOLUTION):
                return "front_side-emotional__icon";
            case (CardType.EMOTIONAL_SOLUTION):
                return "front_side-emotional__icon";
            case (CardType.SOCIAL_SOLUTION):
                return "front_side-social__icon";
            case (CardType.MENTAL_SOLUTION):
                    return "front_side-mental__icon";
            case (CardType.PHYSICAL_SOLUTION):
                return "front_side-physical__icon";
        };
    }

    const flipCardYouHaveEnoughTokens = (cardType: string) => {
        if (tokens > 1 && solutionCardExchanged < 4) {
            flipSolutionCardBySelectedType(cardType);
            setSolutionCardExchanged(solutionCardExchanged + 1);
        }
        if (tokens < 2) {
            setNotificationAlert({message: t("toExchangeYourSolutionCardyouNeedToHaveAtLeast2UpperTokensText"), type:"regular"});
            setActivateAlert(true);
        }
    }

    const drawSolutionCardFromDeck = (cardType: CardType) => {
        let notMappedCard: ICard = game?.gameInfo.players[userData?.email || ""]?.currentSolutionCards[cardType];
        
        if (notMappedCard)
            changeSoultionCardSocketEvent(cardType);

        if (!notMappedCard) {
            switch (cardType) {
                case "Relations": {
                    openNewSolutionCardSocketEvent("Relations"); break;
                }
                case "Physical": {
                    openNewSolutionCardSocketEvent("Physical"); break;
                }
                case "Mental": {
                    openNewSolutionCardSocketEvent("Mental"); break;
                }
                case "Emotional": {
                    openNewSolutionCardSocketEvent("Emotional"); break;
                }
            }
        }
    };

    const clickHandler = (type: CardType) => {
        if (emailOfSelectedPlayerBoard !== userData?.email) {
            setNotificationAlert({message: t("youCanNotExchangeCardsOfTheOtherusersText"), type:"regular"});
            setActivateAlert(true);
            return;
        }

        if (game?.phase !== Phase.QUESTION_CARD){
            setNotificationAlert({message: t("sorryButYouCanExchangeYourSolutionCardOnlyWhenText"), type:"regular"});
            setActivateAlert(true);
        }
        
        if (solutionCardExchanged < 3) {
            switch (type) {
                case CardType.JOKER_SOLUTION:
                    flipCardYouHaveEnoughTokens("emotional");
                    drawSolutionCardFromDeck(CardType.EMOTIONAL_SOLUTION);
                    break;
                case CardType.EMOTIONAL_SOLUTION:
                    flipCardYouHaveEnoughTokens("emotional");
                    drawSolutionCardFromDeck(CardType.EMOTIONAL_SOLUTION);
                    break;
                case CardType.SOCIAL_SOLUTION:
                    flipCardYouHaveEnoughTokens("social");
                    drawSolutionCardFromDeck(CardType.SOCIAL_SOLUTION);
                    break;
                case CardType.MENTAL_SOLUTION:
                    flipCardYouHaveEnoughTokens("mental");
                    drawSolutionCardFromDeck(CardType.MENTAL_SOLUTION);
                    break;
                case CardType.PHYSICAL_SOLUTION:
                    flipCardYouHaveEnoughTokens("physical");
                    drawSolutionCardFromDeck(CardType.PHYSICAL_SOLUTION);
                    break;
                default:
                    return;
            }
        } else { 
                setNotificationAlert({message: t("youCanOnlyExchangeSolutionCardThreeTimesText"), type:"regular"});
                setActivateAlert(true);
        }
    }

    const pinkNotificationExpandTip = () => {
        if (isForceHoverOn && instructionTutorial === "solutionCards")
        return (
            <div className="notification_scale_cards_in_hands" >
                <PinkNotification notificationWidthVW={28} notificationRenderingSide="top" text={t("tipYouCanHoverOverTheCardAndExpandThemText")} moveFromTop={-50} progressNumber={3} />
            </div>
        )
    }

    const pinkNotificationExchangeButtonTip = () => {
        if (isForceHoverOn && instructionTutorial === "solutionCards")
            return (
                <div className="notification_scale_cards_in_hands" >
                    <PinkNotification notificationWidthVW={18} notificationRenderingSide="left" text={t("tipUseExchangeButtonToSwitchBetweenCardsText") } moveFromTop={20} progressNumber={4} />
                </div>
            )
    }

    const pinkNotificationInfoButtonTip = () => {
        if (isForceHoverOn && instructionTutorial === "solutionCards")
            return (
                <div className="notification_scale_cards_in_hands" >
                    <PinkNotification notificationWidthVW={28} notificationRenderingSide="right" text={t("tipClickOnTheInformationButtonToReadMoreText")} moveFromTop={20} progressNumber={2}/>
                </div>
            )
    }

    const exchangeNotificationDirection = () => {
        if (cardData.type === CardType.EMOTIONAL_SOLUTION) return "right";
        return "left";
    }

    const exchangeNotificationTopShift = () => {
        if (cardData.type === CardType.EMOTIONAL_SOLUTION) return -30;
        return 20;
    }

    const pinkNotificationExchangeButton = () => {
        if (isExchangeButtonHovered &&  game?.phase !== Phase.CHOOSE_SOLUTION)
            return <PinkNotification notificationWidthVW={15} notificationRenderingSide={exchangeNotificationDirection()} text={t("exchangeCardText")} moveFromTop={exchangeNotificationTopShift()} />
        if (isExchangeButtonHovered && !isFullScreenOnDuringPhase5 && game?.phase === Phase.CHOOSE_SOLUTION )
        return (
            <div style={{position: "relative", transform: "scale(0.7)", transformOrigin: "right"}}>
                <PinkNotification notificationWidthVW={15} notificationRenderingSide="left" text={t("exchangeCardText")} moveFromTop={20} />
            </div>
        )
    }

    const infoNotificationDirection = () => {
        switch(cardData.type) {
            case CardType.PHYSICAL_SOLUTION: return "left";
            case CardType.JOKER_SOLUTION: return "left";
            default: return "right";
        }   
    }

    const pinkNotificationInfoButton = () => {
        if (isInfoButtonHovered &&  game?.phase !== Phase.CHOOSE_SOLUTION)
            return <PinkNotification notificationWidthVW={16} notificationRenderingSide={infoNotificationDirection()} text={t("clickInfoButtonToLearnMoreText")} moveFromTop={20} />
        if (isInfoButtonHovered && !isFullScreenOnDuringPhase5 && game?.phase === Phase.CHOOSE_SOLUTION)
            return (
                <div style={{position: "absolute", transform: "scale(0.7)", transformOrigin: "left", right: moveInfoNotificationWhenFullScreen()}}>
                    <PinkNotification notificationWidthVW={20} notificationRenderingSide={getInfoNotificationDirection(cardIndex)} text={t("clickInfoButtonToLearnMoreText")} moveFromTop={20} />
                </div>
            )
    }

    const getInfoNotificationDirection = (index: number | undefined) => {
        switch(index){
            case 1: return "right";
            case 2: return "right";
            case 3: return "left";
            case 4: return "left";
            case 5: return "left";
            default: return "right";
        }
    }

    const moveInfoNotificationWhenFullScreen = () => {
        if (cardIndex && cardIndex > 2)
            return "6vh";

        return 0;
    }
    
    const renderSolutionCardTypes = () => {

        return (
            <div
                onClick={() => cardClickHandler(cardData.type)}
                className={`front_side-expand full_screen ${instructionTutorial === "solutionCards" && "white_box_shadow"} ${ (isCardHovered || isForceHoverOn) && "front_side-expand_hovered"} ${((isCardHovered || isForceHoverOn) && !isFullScreenOnDuringPhase5 && !isFullScreenOnDuringPhase7) && "front_side-expand_hovered_bottom"}  ${isFullScreenOnDuringPhase7 && "front_side-expand_hovered"}`}
                onMouseEnter={() => setIsCardHovered(true)}
                onMouseLeave={() => setIsCardHovered(false)}
                id={`${solutionCardsStyle()}`}
                onDoubleClick={doubleClickHandler}
            >
                
                {pinkNotificationExpandTip()}
                <div className={`players_solution_front_side_svg  ${solutionSVGCards()} `} >
                    <div style={{ position: 'absolute', right: 'left' }}
                        onMouseEnter={() => setIsExchangeButtonHovered(true)}
                        onMouseLeave={() => setIsExchangeButtonHovered(false)}
                    >
                        {pinkNotificationExchangeButton()}
                        {pinkNotificationExchangeButtonTip()}
                        {displayExchangeButton && cardData.type !== CardType.JOKER_SOLUTION && 
                            <div style={{position: "absolute", left: 0}} >
                                <SwapButton clickHandler={() => clickHandler(cardData.type)} />
                            </div>
                        }
                    </div>
                    
                    <div onClick={() => setDisplayInfo(!displayInfo)}
                        style={{ position: 'absolute', right: '0' }}
                        onMouseEnter={() => setIsInfoButtonHovered(true)}
                        onMouseLeave={() => setIsInfoButtonHovered(false)}
                    >

                        {pinkNotificationInfoButton()}
                        {pinkNotificationInfoButtonTip()}
                        <div style={{position: "absolute", right: "-3px", top: "-3px"}}> <InfoButton clickHandler={() => setDisplayInfo(!displayInfo)} cardType={cardData.type} solutionCardsInHands={solutionCardsInHands}/> </div>
                    </div>

                    <div className="card_content_wrapper">
                        <p className={fullScreenIsOn ? "solution_card_text_style solution_card_title" : "front_side-title"}>{cardData.title}</p>
                        
                        <div className={`${solutionCardsTextIcon()} ${(isCardHovered || (isForceHoverOn && instructionTutorial === "solutionCards")) && "display_none"} ${isFullScreenOnDuringPhase7 && "display_none"} ${displayInfo && 'card_content_wrapper__hide_icon'}`} />
                        
                        {(displayInfo || displayInfoOnTheProposedCard) && (
                            <div>
                                <p className={fullScreenIsOn ? "solution_card_text_style solution_card_content italic" : "front_side-info"}>{cardData.info}</p>
                            </div>
                        )}

                        {!displayInfo && !displayInfoOnTheProposedCard && (
                            <div>
                                <p className={fullScreenIsOn ? "solution_card_text_style solution_card_content" : "front_side-content"}>{cardData.content} </p>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        );
    };

    return (
        <React.Fragment>
            {renderSolutionCardTypes()}
        </React.Fragment>
    );
}

export default SolutionCard;